import React from 'react'

function Rep_RadiologyLabReports() {
  return (
    <div>Radiology Lab Reports</div>
  )
}

export default Rep_RadiologyLabReports